import React from "react";
import styled from "styled-components";
import videoBg from "../../../assets/images/video-bg.png";
import video from "../../../assets/images/video.png";
import { StaticImage } from "gatsby-plugin-image";
const Hero = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 col-lg-5 text-center text-md-left">
            <h2>Premio Global Quality Gold Elite 2015</h2>
            <h4>
              a Bajatuseguro.com por Alta calidad y excelencia en bienes y
              servicios.
            </h4>
            <StaticImage
              className="img-fluid mb-5 mb-md-0"
              src="../../../assets/images/brand.png"
              alt="brand"
            />
          </div>
          <div className="col-md-5 offset-md-1 col-lg-5 offset-lg-2">
            {/* <div
              className="video-bg"
              style={{
                backgroundImage: `url(${video})`,
                width: "200px",
                height: "400px",
                border: "1px solid red",
              }}
            >
              <a href="#">
                <StaticImage
                  className="video-icon"
                  src="../../../assets/images/video-icon.png"
                  alt="video"
                />
              </a>
            </div> */}
            <div class="video-bg">
              <StaticImage
                className="img-fluid video"
                src="../../../assets/images/video.png"
                alt="video"
              />
              <a href="#">
                <StaticImage
                  className="video-icon"
                  src="../../../assets/images/video-icon.png"
                  alt="video"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Hero;

const Wrapper = styled.section`
  padding: 80px 0;
  background-image: url(${videoBg});
  background-size: contain;
  background-position: 76% 46%;
  background-repeat: no-repeat;
  .video-bg {
    position: relative;
  }
  .video {
    border: 5px solid #fff;
    border-radius: 45px;
    position: relative;
  }

  img {
    vertical-align: middle;
  }
  .img-fluid {
    max-width: 100%;
    height: auto;
  }

  .video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    margin-top: -40px;
    margin-left: -40px;
  }

  h2 {
    color: #5268c2;
    font-weight: 700;
  }

  h4 {
    color: #3cdbc0;
    font-weight: 600;
    margin-bottom: 40px;
    font-size: 22px;
  }
  @media only screen and (max-width: 991px) {
    background-position: 124% 46%;
  }
  @media (max-width: 767px) {
    padding: 30px 0;
    background-position: bottom;
    h2 {
      font-size: 24px;
    }
    h4 {
      font-size: 18px;
      margin-bottom: 20px;
    }
  }
`;
